import { Injectable, StateKey, TransferState, inject, makeStateKey } from '@angular/core';
import { IEnvironment } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class EndpointProvider {
  // Properties
  /** Endpoint for the service, should be overwritten in the child class */
  public endpoint = 'shouldBeOverwritten';
  /** Override URL for the service */
  public overrideServiceUrl?: string;

  // Services
  public readonly transferState = inject(TransferState);

  // Getters & Setters
  /** URL and Endpoint combined */
  get endpointWithUrl(): string {
    return this.url + this.endpoint;
  }
  /** URL for the service */
  get url(): string {
    return this.overrideServiceUrl ?? this.serviceUrl;
  }
  /** Service URL from environment variables */
  public get serviceUrl(): string {
    const key: StateKey<IEnvironment> = makeStateKey<IEnvironment>('env');
    const backendURL = this.transferState.get<IEnvironment>(key, {
      BACKEND_URL: 'shouldBeOverwritten',
      APP_KEY: 'shouldBeOverwritten',
      ENVIRONMENT: 'production',
      BC_APPID: 'shouldBeOverwritten',
      BC_MEMBER_MODULES: 'shouldBeOverwritten',
      BC_MEMBER_NUMBER: 'shouldBeOverwritten',
      BC_PROJECTID: 'shouldBeOverwritten',
      COMMIT_HASH: 'shouldBeOverwritten',
      CHANNEL_ID: 'shouldBeOverwritten',
      DEFAULT_CULTURE: '',
      FIXED_CULTURE: '',
      NATIVE_CULTURE: '',
      CULTURES: ''
    }).BACKEND_URL;
    return backendURL ? backendURL + '/api/' : '';
  }
}
